import { render } from "./MessageLayout.vue?vue&type=template&id=62f92056"
import script from "./MessageLayout.vue?vue&type=script&lang=js"
export * from "./MessageLayout.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__